import { API_BASE_URL, getBlobRequest, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

const certificateUrl = (moduleId, contentId, suffix) =>
    `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/certificate/${suffix}`;

export const fetchLearnerCertificateStatusApi = (moduleId, contentId) =>
    getRequest({
        url: certificateUrl(moduleId, contentId, "status"),
        token: getToken(),
        uid: getUid(),
    });

export const generateLearnerCertificateApi = (moduleId, contentId) =>
    postRequest({
        url: certificateUrl(moduleId, contentId, "generate"),
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const downloadLearnerCertificateApi = (moduleId, contentId) =>
    getBlobRequest({
        url: certificateUrl(moduleId, contentId, "download"),
        token: getToken(),
        extraHeaders: {
            uid: getUid(),
            "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
        },
    });

export const previewLearnerCertificateApi = (moduleId, contentId) =>
    getBlobRequest({
        url: certificateUrl(moduleId, contentId, "preview"),
        token: getToken(),
        extraHeaders: {
            uid: getUid(),
            "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
        },
    });
